export default __webpack_public_path__ + "static/media/Mark-6-HUD-06.968acb69.jpg";